export default __webpack_public_path__ + "static/philosophy-5427a1ceffbd027cd1d94566fdaaa90e.jpeg";